import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const pillarColors = {
  "Strategic Direction": "#DC0706",
  "Marketing System": "#FE4D00",
  "Sales System": "#FF7F00",
  "Operations System": "#FDB714",
  "Systems & Automation": "#02808F",
  "Data & Reporting": "#9CCEFF",
};

export default function QuestionScreen({ question, selectedAnswer, onAnswer }) {
  const pillarColor = pillarColors[question.pillar] || "#DC0706";

  return (
    <motion.div
      initial={{ opacity: 0, x: 40 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -40 }}
      transition={{ duration: 0.3 }}
      data-testid={`question-screen-${question.id}`}
    >
      <div className="mb-6">
        <span
          className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider font-['Albert_Sans']"
          style={{ backgroundColor: `${pillarColor}15`, color: pillarColor, border: `1px solid ${pillarColor}30` }}
          data-testid="pillar-tag"
        >
          {question.pillar}
        </span>
      </div>

      <h2
        className="font-['Albert_Sans'] font-extrabold text-xl sm:text-2xl mb-10 leading-relaxed"
        style={{ color: 'var(--rhz-text-primary)' }}
        data-testid="question-text"
      >
        {question.text}
      </h2>

      <div className="space-y-3">
        {question.options.map((option, i) => {
          const isSelected = selectedAnswer === option.value;
          return (
            <motion.button
              key={option.value}
              data-testid={`option-${option.value}`}
              onClick={() => onAnswer(option.value)}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              className="w-full text-left flex items-center gap-4 p-5 rounded-sm transition-all group"
              style={{
                backgroundColor: isSelected ? 'var(--rhz-elevated)' : 'var(--rhz-surface)',
                border: isSelected ? '1px solid #DC0706' : '1px solid var(--rhz-border)',
              }}
            >
              <div
                className="flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all"
                style={{
                  borderColor: isSelected ? '#DC0706' : 'var(--rhz-border-hover)',
                  backgroundColor: isSelected ? '#DC0706' : 'transparent',
                }}
              >
                {isSelected && <CheckCircle2 className="h-4 w-4 text-white" />}
              </div>
              <span
                className="font-['Albert_Sans'] text-sm leading-relaxed transition-colors"
                style={{ color: isSelected ? 'var(--rhz-text-primary)' : 'var(--rhz-text-secondary)' }}
              >
                {option.label}
              </span>
            </motion.button>
          );
        })}
      </div>
    </motion.div>
  );
}
